import { find } from "lodash";
import { Children, ReactNode, ComponentType } from "react";

export const findOneByType = (children: ReactNode[], type: any) => {
    return find(Children.toArray(children), { type });
};
